module.exports = __webpack_public_path__ + "img/2021_IMG_20210208_104315.43053231.jpg";